import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setLoadingItem, removeLoadingItem } from './EstruturaAntiga/components/loading/loadingActions';
import { errorPage } from './EstruturaAntiga/router/redux/routerActions';
import 'react-notifications/lib/notifications.css';
import './EstruturaAntiga/stylesheets/style.scss';
import './EstruturaAntiga/stylesheets/vendor/icomoon/fonts/icomoon.ttf';
import './EstruturaAntiga/stylesheets/vendor/icomoon/fonts/icomoon.woff';
import './EstruturaAntiga/stylesheets/vendor/icomoon/fonts/icomoon.svg';
import ErrorBoundary from 'EstruturaAntiga/errorBoundary';
import { ConfigProvider } from 'antd';
import GlobalTheme from 'GlobalTheme';
import ptBr from 'antd/locale/pt_BR';
import AppRoutes from 'routers/AppRoutes';
import { NotificationContainer } from 'react-notifications';
import { DrawerProvider } from 'context/DrawerContext';

class App extends Component {
	state = {
		content: [],
		authorized: false
	}

	render() {
		return (
			<div className="app">
				<ErrorBoundary>
					<ConfigProvider theme={GlobalTheme} locale={ptBr}>
						<NotificationContainer className="global-notification" />
						<DrawerProvider>
							<AppRoutes/>
						</DrawerProvider>
					</ConfigProvider>
				</ErrorBoundary>
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => (bindActionCreators({ setLoadingItem, removeLoadingItem, errorPage }, dispatch))
export default connect(null, mapDispatchToProps)(App);